module.exports = __webpack_public_path__ + "static/media/poweredBy-white.bd5cb8d2.svg";